import React from 'react';
import styled from 'styled-components';
import { HeaderTabMenuItem as UiHeaderTabMenuItem } from '@make-software/cspr-design';

export const HeaderTabMenuItem = styled(UiHeaderTabMenuItem)(
  ({ theme, active }) => ({
    ...(!active &&
      theme.themeName === 'light' && {
        color: '#86878f',
      }),
  })
);
